module.exports = __webpack_public_path__ + "img/resized-APP-0013-1.0ec35135.png";